import React from 'react';
import Grid from "@material-ui/core/Grid";
import Head from "./Head";
import {useStore} from "react-redux";
import {useRecoilValue} from "recoil";
import {userState} from "../../state/globalState";

const SentenceForm = ({title, sentences, step, selectItem, isResult}) => {
    const userInfo = useRecoilValue(userState);

    if (title !== undefined) {
        title = title.replace(/\$stdYear\$/gi, userInfo.stdYear);
    }

    const paragraph = sentences.map((sentence, idx) => {
        sentence = sentence.replace(/\$stdYear\$/gi, userInfo.stdYear);
        // if (appStore.getState().user.corprInfo !== null && appStore.getState().user.corprInfo !== undefined) {
        //     sentence = sentence.replace(/\$userName\$/gi, appStore.getState().user.corprInfo.userName);
        //     sentence = sentence.replace(/\$email\$/gi, appStore.getState().user.corprInfo.email);
        //     sentence = sentence.replace(/\$corpNm\$/gi, appStore.getState().user.corprInfo.corprName);
        // }

        return (
            <span key={'paragrah-' + idx} className="sentence" dangerouslySetInnerHTML={ {__html: sentence} } />
        );
    });

    if (isResult) {
        return (
            <React.Fragment>
                <Grid container
                      alignItems="center"
                      justifyContent="center"
                >
                    <div className="blockquote-result">
                        {paragraph}
                    </div>
                </Grid>
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                <Grid container
                      direction="column"
                      alignItems="flex-start"
                      justifyContent="center"
                >
                    <Head title={title} step={step} selectItem={selectItem}/>
                    {paragraph != '' ? (<div className="blockquote-box">
                        {paragraph}
                    </div>) : null}
                </Grid>
            </React.Fragment>
        );
    }
};

export default SentenceForm;
